import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './components/layout/main.scss';
import reportWebVitals from './reportWebVitals';
import Navigation from "./components/layout/navigation";
import Footer from "./components/layout/footer";
import Home from "./components/home/home";
import About from "./components/about/about"
import Request from "./components/request/request";
import ViewCertificate from "./components/viewcertificate/viewcertificate";
import Browse from "./components/browse/browse";
import JudgeSpace from "./components/judgespace/judgespace";


ReactDOM.render(
    <Router>
        <Navigation />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/request" element={<Request />} />
            <Route path="/viewcertificate" element={<ViewCertificate />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/judgespace" element={<JudgeSpace />} />
        </Routes>
        <Footer />
    </Router>,
    document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
